import React from 'react';

const healthCheck = () => { 
    return (
        <div>
            <div>
            <jnpr-navigation jsondata="https://support.juniper.net/support/header.page" />
            <section className="position-relative padding-bottom">
              <div id="content" className="align-center margin-bottom-60 width-1400">
                <div className="wrapper">
                  <div className="slice slice-1col spaced-top spaced-bottom">
                    <div className="slice">
                      <p className="section-title">Health Check Success!</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <jnpr-support-footer jsondata="https://support.juniper.net/support/footer.page" />
            </div>
          </div>
    )
};

export default healthCheck;